import { BUILDER_DOCUMENT_TYPE } from 'hb-react/backoffice/types/builder/builderDocument';

export const DEFAULT_TEMPLATE_FRAME_WIDTH = {
  [BUILDER_DOCUMENT_TYPE.EMAIL]: 800,
  [BUILDER_DOCUMENT_TYPE.PAGE]: 1500,
};

export const DEFAULT_TEMPLATE_WIDTH = {
  [BUILDER_DOCUMENT_TYPE.EMAIL]: 600,
  [BUILDER_DOCUMENT_TYPE.PAGE]: 1200,
};
